module.exports = __webpack_public_path__ + "static/img/keshi3.8d170ef3.webp";